<template>
  <DefaultLayout :pageClass="this.currentStep === 1 ? 'homePage':'defaultPage'">
    <component
        :is="currentComponent"
        :key="currentStep"
        :user-info="userInfo"
        :final-results="finalResults"
        @update-user-info="updateUserInfo"
        @update-answers="updateAnswers"
        @next-step="nextStep"
    />
  </DefaultLayout>
</template>

<script>
import DefaultLayout from "@/layout/DefaultLayout.vue";
import Step0 from './components/Step0.vue';
import Step1 from './components/Step1.vue';
import Step2 from './components/Step2.vue';
import Step3 from './components/Step3.vue';
import Step4 from './components/Step4.vue';
import Step5 from './components/Step5.vue';
import Step6 from './components/Step6.vue';
import Step7 from './components/Step7.vue';

export default {
  name: 'App',
  components: {DefaultLayout, Step0, Step1, Step2, Step3, Step4, Step5, Step6, Step7},
  data() {
    return {
      currentStep: 0,
      steps: ['Step0', 'Step1', 'Step2', 'Step3', 'Step4', 'Step5', 'Step6', 'Step7'],
      userInfo: {
        name: '',
        email: '',
        company: '',
        acceptGdpr: false,
      },
      answers: {
        dreamPower: '',
        wowMoment: '',
        happyPlace: '',
        invest: '',
      },
      scoreMap: {
        dreamPower: {
          pop: {Creative: 22, Contextual: 0, Attention: 0},
          engage: {Creative: 0, Contextual: 22, Attention: 0},
          attention: {Creative: 0, Contextual: 0, Attention: 22}
        },
        wowMoment: {
          remembered: {Creative: 22, Contextual: 0, Attention: 0},
          'engage-context': {Creative: 0, Contextual: 22, Attention: 0},
          'real-attention': {Creative: 0, Contextual: 0, Attention: 22}
        },
        happyPlace: {
          'exceptional-creatives': {Creative: 22, Contextual: 0, Attention: 0},
          'brand-safe': {Creative: 0, Contextual: 22, Attention: 0},
          'elevated-outcomes': {Creative: 0, Contextual: 0, Attention: 22}
        },
        invest: {
          'production-testing': {Creative: 22, Contextual: 0, Attention: 0},
          'data-signals': {Creative: 0, Contextual: 22, Attention: 0},
          'measurement-tech': {Creative: 0, Contextual: 0, Attention: 22}
        }
      },
      finalResults: {
        creativeOptimization: '',
        contextualTargeting: '',
        attentionMeasurement: ''
      }
    }
  },
  created() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('tablet') === 'true') {
      this.currentStep = 0;
      this.currentComponent = 'Step0';
    } else {
      this.currentStep = 1;
      this.currentComponent = 'Step1';
    }
  },
  computed: {
    currentComponent() {
      return `Step${this.currentStep}`;
    }
  },
  methods: {
    adjustPercentages(input, minPercent = 10, maxPercent = 100) {
      let adjusted = {...input};

      for (const key in adjusted) {
        adjusted[key] = Math.max(minPercent, Math.min(maxPercent, adjusted[key]));
      }

      let total = Object.values(adjusted).reduce((a, b) => a + b, 0);
      let diff = 100 - total;

      if (Math.abs(diff) > 0.01) {
        let adjustableKeys = Object.keys(adjusted).filter(key =>
            (diff > 0 && adjusted[key] < maxPercent) ||
            (diff < 0 && adjusted[key] > minPercent)
        );

        let adjustableTotal = adjustableKeys.reduce((sum, key) => sum + adjusted[key], 0);

        if (adjustableTotal > 0 && adjustableKeys.length > 0) {
          for (const key of adjustableKeys) {
            let proportion = adjusted[key] / adjustableTotal;
            let change = proportion * diff;
            adjusted[key] = Math.max(
                minPercent,
                Math.min(maxPercent, adjusted[key] + change)
            );
          }
        } else {
          let candidateKey = Object.keys(adjusted).reduce((a, b) => {
            const roomA = diff > 0 ? maxPercent - adjusted[a] : adjusted[a] - minPercent;
            const roomB = diff > 0 ? maxPercent - adjusted[b] : adjusted[b] - minPercent;
            return roomA > roomB ? a : b;
          });
          adjusted[candidateKey] += diff;
        }
      }

      let roundedSum = 0;
      for (const key in adjusted) {
        adjusted[key] = Math.round(adjusted[key]);
        roundedSum += adjusted[key];
      }
      let roundingDiff = 100 - roundedSum;
      if (roundingDiff !== 0) {
        let fixKey = Object.keys(adjusted).reduce((a, b) =>
            adjusted[a] > adjusted[b] ? a : b
        );
        adjusted[fixKey] += roundingDiff;
      }

      this.finalResults.creativeOptimization = adjusted.creativeOptimization;
      this.finalResults.contextualTargeting = adjusted.contextualTargeting;
      this.finalResults.attentionMeasurement = adjusted.attentionMeasurement;

      return adjusted;
    },
    getAdjustedScores(scoreMap, answer) {
      let creativeOptimization = 0;
      let contextualTargeting = 0;
      let attentionMeasurement = 0;

      ['dreamPower', 'wowMoment', 'happyPlace', 'invest'].forEach(key => {
        const val = answer[key];
        if (val && scoreMap[key][val]) {
          const scores = scoreMap[key][val];
          creativeOptimization += scores.Creative;
          contextualTargeting += scores.Contextual;
          attentionMeasurement += scores.Attention;
        }
      });

      return this.adjustPercentages({creativeOptimization, contextualTargeting, attentionMeasurement})
    },
    async updateAnswers(newAnswers) {
      this.answers = {...this.answers, ...newAnswers};
      if (this.answers.dreamPower !== '' &&
          this.answers.wowMoment !== '' &&
          this.answers.happyPlace !== '' &&
          this.answers.invest !== '') {
        console.log(this.answers);
        const result = this.getAdjustedScores(this.scoreMap, this.answers);

        let dataForCollectionData = {
          ...result,
          email: this.userInfo.email,
        }
        console.log(dataForCollectionData);
        await fetch('https://form-to-kv-worker.ocm.workers.dev/', {
          method: 'POST',
          body: JSON.stringify(dataForCollectionData),
          headers: {'content-type': 'application/json'}
        }).then(response => {
          console.log(response.status)
        }).catch(error => console.error('Error upload user:', error));
      }
      this.nextStep();
    },
    updateUserInfo(newUserInfo) {
      this.userInfo = newUserInfo;
    },
    nextStep() {
      this.currentStep++;
      window.scrollTo(0, 0);
    },
  },
}
</script>